// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup .add-menu {
  padding: 50px 20px 20px 20px;
}
.popup .add-menu form {
  margin-top: 4%;
}
.popup .add-menu h2 {
  font: 2em/1 vigaregular;
  color: #5c5c5c;
}
.popup .add-menu .add-menu-choose {
  margin-top: 10%;
  margin-bottom: 4%;
}
.popup .add-menu textarea {
  margin-top: 5%;
  width: 100%;
  border-radius: 5px;
  height: 22vh;
  border: 0;
  box-sizing: border-box;
  font: 1.4em/1 vigaregular;
  padding: 5% 5% 5% 5%;
  background-color: #f5f5f5;
  resize: none;
  color: #5c5c5c;
}
.popup .add-menu textarea::placeholder {
  opacity: 0.5;
}
.popup .add-menu .error {
  font: 1.2em/1 vigaregular;
  color: #000;
  padding-top: 2%;
  padding-bottom: 2%;
}
.popup .add-menu input,
.popup .add-menu select {
  background-color: #f5f5f5;
  width: 100%;
  border-radius: 6px;
  outline: none;
  padding: 7% 5%;
  /*  padding: 7% 0% 7% 5%; */
  /* margin-bottom: 4%;*/
  border: 0;
  box-sizing: border-box;
  font: 1.4em/1 vigaregular;
  color: #5c5c5c;
}
.popup .add-menu input::placeholder,
.popup .add-menu select::placeholder {
  opacity: 0.5;
}
.popup .add-menu input[name=price] {
  width: 50%;
}
.popup .add-menu .row-checkbox {
  display: flex;
  align-items: center;
}
.popup .add-menu .row-checkbox .label-checkbox {
  font: 2em/1 vigaregular;
  color: #5c5c5c;
}
.popup .add-menu .row-checkbox input[type=checkbox] {
  background-color: #F2F2F2;
  color: #caa36c;
  border: none;
  border-radius: 6px;
  display: inline-block;
  width: 30px;
  height: 30px;
  padding: 0;
  margin-right: 15px;
  -webkit-appearance: none;
  position: relative;
}
.popup .add-menu .row-checkbox input[type=checkbox]:checked:after {
  content: "\\e90f";
  font-family: "icomoon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.popup .add-menu .link {
  font-family: "vigaregular";
  font-size: 14px;
  line-height: 19px;
  text-decoration-line: underline;
  color: #5C5C5C;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/popups/AddTabContent.scss"],"names":[],"mappings":"AACI;EACI,4BAAA;AAAR;AAEQ;EACI,cAAA;AAAZ;AAGQ;EACI,uBAAA;EACA,cAAA;AADZ;AAIQ;EACI,eAAA;EACA,iBAAA;AAFZ;AAKQ;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,sBAAA;EACA,yBAAA;EACA,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;AAHZ;AAKY;EACI,YAAA;AAHhB;AAMQ;EACI,yBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAJZ;AAOQ;;EAEI,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACF,2BAAA;EACC,sBAAA;EACC,SAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AALZ;AAOY;;EACI,YAAA;AAJhB;AAQQ;EACI,UAAA;AANZ;AAQQ;EACI,aAAA;EACA,mBAAA;AANZ;AAQY;EACI,uBAAA;EACA,cAAA;AANhB;AASY;EACI,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;AAPhB;AAWoB;EACI,gBAAA;EACA,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,mCAAA;EACA,kCAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AATxB;AAeQ;EACI,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,cAAA;AAbZ","sourcesContent":[".popup {\n    .add-menu {\n        padding: 50px 20px 20px 20px;\n\n        form {\n            margin-top: 4%;\n        }\n\n        h2 {\n            font: 2em/1 vigaregular;\n            color: #5c5c5c;\n        }\n\n        .add-menu-choose {\n            margin-top: 10%;\n            margin-bottom: 4%;\n        }\n\n        textarea {\n            margin-top: 5%;\n            width: 100%;\n            border-radius: 5px;\n            height: 22vh;\n            border: 0;\n            box-sizing: border-box;\n            font: 1.4em/1 vigaregular;\n            padding: 5% 5% 5% 5%;\n            background-color: #f5f5f5;\n            resize: none;\n            color: #5c5c5c;\n\n            &::placeholder {\n                opacity: 0.5;\n            }\n        }\n        .error {\n            font: 1.2em/1 vigaregular;\n            color: #000;\n            padding-top: 2%;\n            padding-bottom: 2%;\n        }\n\n        input,\n        select {\n            background-color: #f5f5f5;\n            width: 100%;\n            border-radius: 6px;\n            outline: none;\n            padding: 7% 5%;\n          /*  padding: 7% 0% 7% 5%; */\n           /* margin-bottom: 4%;*/\n            border: 0;\n            box-sizing: border-box;\n            font: 1.4em/1 vigaregular;\n            color: #5c5c5c;\n\n            &::placeholder {\n                opacity: 0.5;\n            }\n        }\n\n        input[name=\"price\"] {\n            width: 50%;\n        }\n        .row-checkbox{\n            display: flex;\n            align-items: center;\n            \n            .label-checkbox{\n                font: 2em/1 vigaregular;\n                color: #5c5c5c;\n            }\n                \n            input[type='checkbox'] {\n                background-color: #F2F2F2;\n                color: #caa36c;\n                border: none;\n                border-radius: 6px;\n                display: inline-block;\n                width: 30px;\n                height: 30px;\n                padding: 0;\n                margin-right: 15px;\n                -webkit-appearance: none;\n                position: relative;\n            \n                &:checked{\n            \n                    &:after{\n                        content: \"\\e90f\";\n                        font-family: 'icomoon' !important;\n                        speak: never;\n                        font-style: normal;\n                        font-weight: normal;\n                        font-variant: normal;\n                        text-transform: none;\n                        line-height: 1;\n                        -webkit-font-smoothing: antialiased;\n                        -moz-osx-font-smoothing: grayscale;\n                        position: absolute;\n                        left: 50%;\n                        top: 50%;\n                        transform: translate(-50%, -50%);\n                    }\n                }\n            }\n        }\n\n        .link{\n            font-family: 'vigaregular';\n            font-size: 14px;\n            line-height: 19px;\n            text-decoration-line: underline;\n            color: #5C5C5C;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
